import DjangoMessages from 'components/DjangoMessages';
import NavigationTabs from 'components/Navigation/NavigationTabs';
import {FC, ReactNode} from 'react';

import CompanyHeader from '../../CompanyHeader';
import LoggedInHeader from '../../LoggedInHeader';
import PortalPageLayout from '../../PortalPageLayout';
import {PortalPermissions} from '../types';

type InboxLayoutProps = {
    children?: ReactNode;
    clientName: string;
    email: string;
    flags: {
        portalAllowClientinboxUsersToEditUsers?: boolean;
    };
    navigation: string;
    partnerName: string;
    permissions: PortalPermissions;
    portalMid: string;
    sessionExpiration: number;
};

const InboxLayout: FC<InboxLayoutProps> = ({
    children,
    clientName,
    email,
    flags,
    navigation,
    partnerName,
    permissions,
    portalMid,
    sessionExpiration,
}) => (
    <PortalPageLayout
        className="mx-4 flex flex-1 flex-col"
        isResponsive={false}
    >
        <LoggedInHeader email={email} sessionExpiration={sessionExpiration} />
        <CompanyHeader clientName={clientName} partnerName={partnerName} />
        <NavigationTabs.Portal
            className="mt-4"
            flags={flags}
            mid={portalMid}
            permissions={permissions}
            selection={navigation}
        />
        <DjangoMessages className="mb-0 mt-4" />
        {children}
    </PortalPageLayout>
);
export default InboxLayout;
